import React, { Component } from 'react';
import Page from '../../components/Page/Page';
import SideImage from '../../components/SideImage/SideImage';

class PageEnvironment extends Component {

  render() {
        return (
            <Page primaryTitle="Environmental Statement" secondaryTitle="" section="">
                <div className="col-sm-8 col-sm-push-4 col-lg-9 col-lg-push-3 pageEnvironment">
                    <p className="intro">SLA Service Management is committed to doing it's part to minimize the impact of it's activities on the environment.</p>

                    <h3>Our goals are:</h3>
                    <ul>
                        <li>To minimize waste through constant monitoring of operations to ensure that they are as efficient as possible.</li>
                        <li>To promote the three "R"s (recycling, reuse and reduction), both internally and among customers and suppliers.</li>
                        <li>To seek education and advice on environmental issues to improve our green efforts.</li>
                        <li>To be an active participant in community activities geared toward environmental awareness and protection.</li>
                    </ul>
                    
                </div>
                <aside className="col-sm-4 col-sm-pull-8 col-lg-3 col-lg-pull-9 sidebar">
                <SideImage page={this.props.page} />
                </aside>
            </Page>
        );
    }
}

export default PageEnvironment;



// WEBPACK FOOTER //
// ./src/pages/PageEnvironment/PageEnvironment.js